<template>
  <div id="app" :class="appClasses">
    <!-- <div class="timeOut">{{time}}</div> -->
    <transition name="slide" mode="out-in">
      <router-view/>
    </transition>
    <CancelSignUp></CancelSignUp>
    <TermsAndConditions></TermsAndConditions>
    <StillThere v-if="stillThere" ref="stillThere" :startTimer="startTimers"></StillThere>
    <div class="keyboardCloseButton">
        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width="100%" height="50%" viewBox="0 0 510 510" style="enable-background:new 0 0 510 510;" xml:space="preserve">
        <g>
          <g id="keyboard-hide">
            <path d="M459,0H51C22.95,0,0,22.95,0,51v255c0,28.05,22.95,51,51,51h408c28.05,0,51-22.95,51-51V51C510,22.95,487.05,0,459,0z
              M229.5,76.5h51v51h-51V76.5z M229.5,153h51v51h-51V153z M153,76.5h51v51h-51V76.5z M153,153h51v51h-51V153z M127.5,204h-51v-51
              h51V204z M127.5,127.5h-51v-51h51V127.5z M357,306H153v-51h204V306z M357,204h-51v-51h51V204z M357,127.5h-51v-51h51V127.5z
              M433.5,204h-51v-51h51V204z M433.5,127.5h-51v-51h51V127.5z M255,510l102-102H153L255,510z"/>
          </g>
        </g>
        </svg>
        <span>Close Keyboard</span>
    </div>
  </div>
</template>


<script>
import CancelSignUp from "./components/popups/CancelSignup";
import TermsAndConditions from "./components/popups/TermsAndConditions";
import StillThere from "./components/popups/StillThere";
export default {
  components: {
    CancelSignUp,
    TermsAndConditions,
    StillThere
  },
  data() {
    return {
      timeoutID: null,
      startTimers: false,
      time: 400000000,
      stillThere: false
    };
  },
  computed: {
    appClasses() {
      let type = this.$store.state.loyaltyType;
      if(type === 'personal') {
        return "isPersonal";  
      }

      if (type === 'pensioner') {
        return "isPensioner"
      }
      return "isBusiness";
    }
  },
  methods: {
    checkUserActive() {
      document.addEventListener("mousemove", this.resetTimer, false);
      document.addEventListener("mousedown", this.resetTimer, false);
      document.addEventListener("keypress", this.resetTimer, false);
      document.addEventListener("DOMMouseScroll", this.resetTimer, false);
      document.addEventListener("mousewheel", this.resetTimer, false);
      document.addEventListener("touchmove", this.resetTimer, false);
      document.addEventListener("MSPointerMove", this.resetTimer, false);
      
      this.startTimer();
    },
    startTimer() {
      this.timeoutID = window.setTimeout(this.goInactive, this.time);
    },
    resetTimer() {
      clearTimeout(this.timeoutID);
      if (!this.stillThere) {
        this.goActive();
        clearTimeout(this.timeoutID);
      }
      this.startTimer();
    },
    goInactive() {
      if (this.$route.name !== "welcome") {
        document.body.classList.add("stillThere");
        this.stillThere = true;
        this.startTimers = true;
        clearTimeout(this.timeoutID);
      }
    },
    goActive() {
      document.body.classList.remove("stillThere");
      this.startTimers = false;
      this.stillThere = false;
      this.startTimer();
    }
  },
  created() {
    this.checkUserActive();
  }
};
</script>



